export const PRO_FEATURES = {
  RECURRING_INVOICES: "Recurring invoices & milestone billing",
  PROGRESS_PAYMENTS: "Progress payments (milestone billing)",
  IMPORT_EXPORT: "Import & export page",
  COST_CATALOGUE: "Access to the full cost catalog",
  COST_CATALOGUE_ADD: "Adding new costs to the cost catalog",
  PRODUCT_COST_ADD: "Adding costs to products/services",
  EMAIL_SENDING: "Email sending (quotes, invoices, etc.)",
  EMAIL_DEFAULTS: "Email default settings (pre-filled subject & body)",
  FILE_ATTACHMENTS: "File attachments",
  INVOICE_FOOTER: "Editing the quote/invoice footer",
  COMPANY_LOGO: "Your logo on quotes and invoices",
  ACCENT_COLOR: "Your brand color on quotes and invoices",
  TEMPLATES: "Reusable quote & invoice templates",
  BILLING: "Billing & subscription management",
  STRIPE_CONNECT: "Accepting online payments via Stripe",
  INTEGRATIONS: "Integrations & connected apps",
  LINE_ITEM_GROUPS: "Line item groups",
  PROJECTS: "Projects (job tracking & actual costs)",
} as const;

export type ProFeatureKey = keyof typeof PRO_FEATURES;
